import PrintIcon from './component'

export default PrintIcon
